// crewbit-admin/src/hooks/useEnableStripeFeatures.ts
//
// Tier 2 Phase E §WorldClass.5 — Stripe Connect deep substrate.
// Admin paired hook for enable_stripe_connect_features RPC (Migration 276).
// Mirrors crewbit-mobile/hooks/useEnableStripeFeatures.ts.
// Web runtime emits MONEY_MUTATION_EVENT via window.dispatchEvent on success.

import { useCallback } from 'react';
import { callMoneyRpc, type MoneyRpcResult } from '../lib/moneyRpc';
import { MONEY_MUTATION_EVENT } from './useFinancialSummary';
import type { StripeFeaturesPayload, StripeFeatureKey } from '../types/stripeFeatures';

export interface EnableStripeFeaturesArgs {
  businessId: string;
  features: StripeFeaturesPayload;
}

export type EnableStripeFeaturesHookResult = MoneyRpcResult<{
  business_id: string;
  updated_features: Partial<Record<StripeFeatureKey, boolean>>;
}>;

export function useEnableStripeFeatures() {
  return useCallback(
    async (args: EnableStripeFeaturesArgs): Promise<EnableStripeFeaturesHookResult> => {
      const result = await callMoneyRpc<{
        business_id: string;
        updated_features: Partial<Record<StripeFeatureKey, boolean>>;
      }>('enable_stripe_connect_features', {
        p_business_id: args.businessId,
        p_features: args.features,
      });
      if (result.success) {
        window.dispatchEvent(new Event(MONEY_MUTATION_EVENT));
      }
      return result;
    },
    [],
  );
}
